import { ArrowUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function InitialHero({ onAsk }: { onAsk: (text: string) => void }) {
  const { t } = useTranslation();
  return (
    <div className="px-2 sm:px-4">
      <div className="flex flex-col items-center text-center">
        <img src="/logoIcon.svg" width={73} height={74} alt="Logo" className="w-16 h-16 sm:w-[73px] sm:h-[74px]" />
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#001E30] mt-4 sm:mt-6">
          {t('chatBot.hero.title')}
        </h1>
        <p className="max-w-2xl my-4 sm:my-6 md:my-8 text-sm sm:text-base text-[#474747] px-2">
          {t('chatBot.hero.description')}
        </p>

        <div className="flex mx-auto justify-center flex-wrap gap-2 sm:gap-3 md:gap-4 w-full px-2">
          <HeroCard
            text={t('chatBot.hero.sampleQuestions.opportunities')}
            onClick={() => onAsk(t('chatBot.hero.sampleQuestions.opportunities'))}
          />
          <HeroCard
            text={t('chatBot.hero.sampleQuestions.benefits')}
            onClick={() => onAsk(t('chatBot.hero.sampleQuestions.benefits'))}
          />
          <HeroCard
            text={t('chatBot.hero.sampleQuestions.facilities')}
            onClick={() => onAsk(t('chatBot.hero.sampleQuestions.facilities'))}
          />
        </div>
      </div>
    </div>
  );
}

function HeroCard({ text, onClick }: { text: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="group flex gap-1.5 sm:gap-2 items-center rounded-xl sm:rounded-2xl bg-[#EBF3F7] cursor-pointer transition-colors p-2.5 sm:p-3 md:p-4 shadow-sm hover:bg-[#dbe9f0] w-full sm:w-auto"
    >
      <p className="text-[#0F172A] leading-relaxed text-xs sm:text-sm md:text-base text-left sm:text-center">{text}</p>
      <ArrowUpRight
        className="w-4 h-4 sm:w-5 sm:h-5 text-[#005287] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 flex-shrink-0"
        aria-hidden="true"
      />
    </button>
  );
}
